var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "item-specs" }, [
    _c(
      "h3",
      [
        _vm._t("default", function () {
          return [_vm._v("Spec Label")]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.topic === "dimensions"
      ? _c("ul", [
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.form"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_form
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_form)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.spannweite"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_spannweite
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_spannweite)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "p",
              {
                staticClass: "label-container",
                staticStyle: { "min-height": "60px" },
              },
              [_vm._v(_vm._s(_vm.t("compare.hoehe")))]
            ),
            _vm._v(" "),
            _vm.data.compare_hoehe
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_hoehe)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.durchgangshoehe"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_durchgangshoehe
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_durchgangshoehe)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.schliesshoehe"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_schliesshoehe
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_schliesshoehe)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.schirmgewicht"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_schirmgewicht
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_schirmgewicht)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.windstabilitaet"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_windstabilitaet
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_windstabilitaet)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.gestellfarbe"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_gestellfarbe
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_gestellfarbe)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.teiligkeit"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_teiligkeit
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_teiligkeit)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.material"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_material
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_material)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.topic === "quality"
      ? _c("ul", [
          _c("li", [
            _c("div", { staticClass: "label-container" }, [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.t("compare.stoffklasse")) +
                    "\n                    "
                ),
                _vm.tooltips.compare_stoffklasse_tooltip
                  ? _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("inline-svg", {
                          attrs: { src: "/img/icon_info.svg" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-compare" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.tooltips.compare_stoffklasse_tooltip)
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.data.compare_stoffklasse
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_stoffklasse)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.volant"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_volant
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_volant)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "label-container" }, [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.t("compare.uvschutz")) + "\n                    "
                ),
                _vm.tooltips.compare_uvschutz_tooltip
                  ? _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("inline-svg", {
                          attrs: { src: "/img/icon_info.svg" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-compare" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.tooltips.compare_uvschutz_tooltip)
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.data.compare_uvschutz
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_uvschutz)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "label-container" }, [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.t("compare.flaechengewicht")) +
                    "\n                    "
                ),
                _vm.tooltips.compare_flaechengewicht_tooltip
                  ? _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("inline-svg", {
                          attrs: { src: "/img/icon_info.svg" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-compare" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.tooltips.compare_flaechengewicht_tooltip
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.data.compare_flaechengewicht
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_flaechengewicht)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "label-container" }, [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.t("compare.lichtechtheit")) +
                    "\n                    "
                ),
                _vm.tooltips.compare_lichtechtheit_tooltip
                  ? _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("inline-svg", {
                          attrs: { src: "/img/icon_info.svg" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-compare" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.tooltips.compare_lichtechtheit_tooltip)
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.data.compare_lichtechtheit
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_lichtechtheit)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "label-container" }, [
              _c("p", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(_vm.t("compare.wassersaeule")) +
                    "\n                    "
                ),
                _vm.tooltips.compare_wassersaeule_tooltip
                  ? _c(
                      "span",
                      { staticClass: "icon" },
                      [
                        _c("inline-svg", {
                          attrs: { src: "/img/icon_info.svg" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tooltip-compare" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(
                              _vm._s(_vm.tooltips.compare_wassersaeule_tooltip)
                            ),
                          ]),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.data.compare_wassersaeule
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_wassersaeule)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.topic === "accessories"
      ? _c("ul", [
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.befestigung"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_befestigung
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_befestigung)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.beleuchtung"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_beleuchtung
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_beleuchtung)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", { staticClass: "label-container" }, [
              _vm._v(_vm._s(_vm.t("compare.schutzhuelle"))),
            ]),
            _vm._v(" "),
            _vm.data.compare_schutzhuelle
              ? _c("p", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.data.compare_schutzhuelle)),
                ])
              : _c("p", { staticClass: "value" }, [_vm._v("–")]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }